import { FC, useCallback } from 'react';

export interface FormDeleteIconButtonProps {
  className?: string;
  onClick?(): void;
}

export const FormDeleteIconButton: FC<FormDeleteIconButtonProps> = props => {
  const { onClick } = props;
  const onChange = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <button data-e2e="batch-delete-form-button" className={`${props.className} btn btn-sm btn-link`} onClick={onChange}>
      <i className="icon icon-sm">delete</i>
    </button>
  );
};
